import { render, staticRenderFns } from "./InvestorNavbarVertical.vue?vue&type=template&id=0e8dbe67&"
import script from "./InvestorNavbarVertical.vue?vue&type=script&lang=js&"
export * from "./InvestorNavbarVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports